import React from "react";
import { Container, Row, Col, Nav, Tab } from "react-bootstrap";
import "../styles/termsAndPrivacy.css";

const TermsAndPrivacy = () => {
  return (
    <div className="terms-privacy-container">
      <Container>
        <h1 className="text-center mb-5">Terms of Use & Privacy Policy</h1>

        <Tab.Container id="terms-privacy-tabs" defaultActiveKey="terms">
          <Row>
            <Col md={3}>
              <Nav variant="pills" className="flex-column terms-privacy-nav">
                <Nav.Item>
                  <Nav.Link eventKey="terms">Terms of Use</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="privacy">Privacy Policy</Nav.Link>
                </Nav.Item>
              </Nav>
            </Col>
            <Col md={9}>
              <Tab.Content className="terms-privacy-content">
                <Tab.Pane eventKey="terms">
                  <h2>Terms of Use</h2>
                  <p className="last-updated">Last Updated: July 26, 2025</p>

                  <section>
                    <h3>1. Acceptance of Terms</h3>
                    <p>
                      Welcome to PrepLetter. By accessing or using our website,
                      services, or applications (collectively, the "Services"),
                      you agree to be bound by these Terms of Use ("Terms"). If
                      you do not agree to these Terms, please do not use our
                      Services.
                    </p>
                    <p>
                      These Terms constitute a legally binding agreement between
                      you and PrepLetter, a product from RolePilot.AI ("we,"
                      "us," or "our"). These Terms may be updated from time to
                      time without notice. Your continued use of the Services
                      following any changes constitutes your acceptance of such
                      changes.
                    </p>
                  </section>

                  <section>
                    <h3>2. Description of Services</h3>
                    <p>
                      PrepLetter provides coding interview preparation content
                      delivered via email, web-based quizzes, and related
                      educational resources. Our Services include, but are not
                      limited to:
                    </p>
                    <ul>
                      <li>Daily coding problems and solutions</li>
                      <li>Interactive quizzes and assessments</li>
                      <li>
                        Educational content related to data structures and
                        algorithms
                      </li>
                      <li>User account management</li>
                    </ul>
                  </section>

                  <section>
                    <h3>3. User Accounts</h3>
                    <p>
                      To access certain features of our Services, you may need
                      to create an account by providing your email address. You
                      are responsible for maintaining the confidentiality of
                      your account information and for all activities that occur
                      under your account.
                    </p>
                    <p>
                      You agree to provide accurate and complete information
                      when creating an account and to update your information to
                      keep it accurate and current. We reserve the right to
                      suspend or terminate your account if any information
                      provided proves to be inaccurate, false, or outdated.
                    </p>
                  </section>

                  <section>
                    <h3>4. User Conduct</h3>
                    <p>By using our Services, you agree not to:</p>
                    <ul>
                      <li>
                        Use the Services for any illegal purpose or in violation
                        of any local, state, national, or international law
                      </li>
                      <li>
                        Violate or infringe other people's intellectual
                        property, privacy, publicity, or other legal rights
                      </li>
                      <li>Impersonate another person or entity</li>
                      <li>
                        Interfere with or disrupt the Services or servers or
                        networks connected to the Services
                      </li>
                      <li>
                        Attempt to gain unauthorized access to any portion of
                        the Services
                      </li>
                      <li>
                        Use any robot, spider, or other automated device to
                        access the Services
                      </li>
                      <li>
                        Transmit any viruses, worms, defects, Trojan horses, or
                        other items of a destructive nature
                      </li>
                    </ul>
                  </section>

                  <section>
                    <h3>5. Intellectual Property</h3>
                    <p>
                      All content included in or made available through our
                      Services, including text, graphics, logos, icons, images,
                      audio clips, digital downloads, and data compilations, is
                      the property of PrepLetter or its content suppliers and is
                      protected by copyright, trademark, and other intellectual
                      property laws.
                    </p>
                    <p>
                      We grant you a limited, non-exclusive, non-transferable,
                      and revocable license to access and use the Services for
                      your personal, non-commercial use. This license does not
                      include:
                    </p>
                    <ul>
                      <li>Modifying or copying the materials</li>
                      <li>Using the materials for any commercial purpose</li>
                      <li>
                        Attempting to decompile or reverse engineer any software
                        contained on PrepLetter's website
                      </li>
                      <li>
                        Removing any copyright or other proprietary notations
                        from the materials
                      </li>
                      <li>
                        Transferring the materials to another person or
                        "mirroring" the materials on any other server
                      </li>
                    </ul>
                  </section>

                  <section>
                    <h3>6. Termination</h3>
                    <p>
                      We may terminate or suspend your access to all or part of
                      our Services, without notice, for any conduct that we, in
                      our sole discretion, believe violates these Terms or is
                      harmful to other users of the Services, us, or third
                      parties, or for any other reason.
                    </p>
                  </section>

                  <section>
                    <h3>7. Disclaimer of Warranties</h3>
                    <p>
                      THE SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE"
                      WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED,
                      INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF
                      MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR
                      NON-INFRINGEMENT.
                    </p>
                    <p>
                      We do not warrant that the Services will be uninterrupted
                      or error-free, that defects will be corrected, or that the
                      Services or the servers that make them available are free
                      of viruses or other harmful components.
                    </p>
                  </section>

                  <section>
                    <h3>8. Limitation of Liability</h3>
                    <p>
                      TO THE FULLEST EXTENT PERMITTED BY LAW, PREPLETTER SHALL
                      NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
                      CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS
                      OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR
                      ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE
                      LOSSES, RESULTING FROM:
                    </p>
                    <ul>
                      <li>
                        YOUR ACCESS TO OR USE OF OR INABILITY TO ACCESS OR USE
                        THE SERVICES
                      </li>
                      <li>
                        ANY CONDUCT OR CONTENT OF ANY THIRD PARTY ON THE
                        SERVICES
                      </li>
                      <li>ANY CONTENT OBTAINED FROM THE SERVICES</li>
                      <li>
                        UNAUTHORIZED ACCESS, USE, OR ALTERATION OF YOUR
                        TRANSMISSIONS OR CONTENT
                      </li>
                    </ul>
                  </section>

                  <section>
                    <h3>9. Governing Law</h3>
                    <p>
                      These Terms shall be governed by and construed in
                      accordance with the laws of the jurisdiction in which
                      PrepLetter operates, without regard to its conflict of law
                      provisions.
                    </p>
                  </section>

                  <section>
                    <h3>10. Changes to Terms</h3>
                    <p>
                      We reserve the right to modify or replace these Terms at
                      any time. If a revision is material, we will provide at
                      least 30 days' notice prior to any new terms taking
                      effect. What constitutes a material change will be
                      determined at our sole discretion.
                    </p>
                  </section>

                  <section>
                    <h3>11. Contact Us</h3>
                    <p>
                      If you have any questions about these Terms, please
                      contact us at{" "}
                      <a href="mailto:hello@rolepilot.ai">hello@rolepilot.ai</a>
                      .
                    </p>
                  </section>
                </Tab.Pane>

                <Tab.Pane eventKey="privacy">
                  <h2>Privacy Policy</h2>
                  <p className="last-updated">Last Updated: July 26, 2025</p>

                  <section>
                    <h3>1. Introduction</h3>
                    <p>
                      PrepLetter ("we," "us," or "our") is committed to
                      protecting your privacy. This Privacy Policy explains how
                      we collect, use, disclose, and safeguard your information
                      when you use our website, services, or applications
                      (collectively, the "Services").
                    </p>
                    <p>
                      Please read this Privacy Policy carefully. By using our
                      Services, you consent to the collection, use, and
                      disclosure of your information as described in this
                      Privacy Policy.
                    </p>
                  </section>

                  <section>
                    <h3>2. Information We Collect</h3>
                    <p>We may collect the following types of information:</p>
                    <h4>2.1 Personal Information</h4>
                    <p>
                      Personal information is data that can be used to identify
                      you directly or indirectly. We collect the following
                      personal information:
                    </p>
                    <ul>
                      <li>
                        <strong>Email Address:</strong> We collect your email
                        address when you subscribe to our newsletter, create an
                        account, or contact us.
                      </li>
                      <li>
                        <strong>User Preferences:</strong> Information about
                        your preferences for receiving content and
                        communications.
                      </li>
                      <li>
                        <strong>Quiz and Survey Responses:</strong> Information
                        you provide when participating in quizzes or surveys.
                      </li>
                    </ul>

                    <h4>2.2 Usage Data</h4>
                    <p>
                      We automatically collect certain information about how you
                      interact with our Services:
                    </p>
                    <ul>
                      <li>
                        <strong>Email Tracking:</strong> We use pixel tracking
                        to verify when you have opened emails sent by us. This
                        helps us understand engagement and improve our services.
                      </li>
                      <li>
                        <strong>Analytics Data:</strong> We use Google Analytics
                        to collect information about how you use our Services,
                        including:
                        <ul>
                          <li>Pages visited and time spent on those pages</li>
                          <li>Referring websites or sources</li>
                          <li>Device and browser information</li>
                          <li>Geographic location (country and city level)</li>
                          <li>Actions taken on our Services</li>
                        </ul>
                      </li>
                      <li>
                        <strong>Log Data:</strong> Our servers automatically
                        record information created by your use of our Services,
                        including IP address, browser type, operating system,
                        referring URLs, and timestamps.
                      </li>
                    </ul>
                  </section>

                  <section>
                    <h3>3. How We Use Your Information</h3>
                    <p>
                      We use the information we collect for various purposes,
                      including to:
                    </p>
                    <ul>
                      <li>Provide, maintain, and improve our Services</li>
                      <li>
                        Send you technical notices, updates, security alerts,
                        and support messages
                      </li>
                      <li>
                        Deliver content tailored to your interests and
                        preferences
                      </li>
                      <li>
                        Monitor and analyze trends, usage, and activities in
                        connection with our Services
                      </li>
                      <li>
                        Detect, investigate, and prevent fraudulent transactions
                        and other illegal activities
                      </li>
                      <li>Respond to your comments, questions, and requests</li>
                      <li>
                        Measure the effectiveness of our email communications
                      </li>
                      <li>Improve our content and marketing efforts</li>
                    </ul>
                  </section>

                  <section>
                    <h3>4. Email Tracking Disclosure</h3>
                    <p>
                      Our emails may contain a single-pixel GIF image (also
                      known as a "web beacon" or "tracking pixel") that allows
                      us to determine whether you have opened an email we've
                      sent and when. This information helps us:
                    </p>
                    <ul>
                      <li>
                        Understand if our emails are being delivered properly
                      </li>
                      <li>Measure engagement with our content</li>
                      <li>Improve our email content and delivery timing</li>
                    </ul>
                    <p>
                      This tracking is a standard practice in email marketing
                      and delivery services. If you prefer not to be tracked in
                      this way, you can:
                    </p>
                    <ul>
                      <li>
                        Disable images in your email client, as the tracking
                        pixel is an image
                      </li>
                      <li>
                        Unsubscribe from our emails using the link provided in
                        each email
                      </li>
                    </ul>
                  </section>

                  <section>
                    <h3>5. Google Analytics</h3>
                    <p>
                      We use Google Analytics to help us understand how users
                      engage with our Services. Google Analytics uses cookies
                      and similar technologies to collect and analyze
                      information about the use of our Services and to report on
                      activities and trends.
                    </p>
                    <p>
                      Google Analytics may also collect information regarding
                      your use of other websites, apps, and online resources.
                      You can learn about Google's practices by going to{" "}
                      <a
                        href="https://policies.google.com/technologies/partner-sites"
                        target="_blank"
                        rel="noreferrer"
                      >
                        https://policies.google.com/technologies/partner-sites
                      </a>
                      , and opt out of them by downloading the Google Analytics
                      opt-out browser add-on, available at{" "}
                      <a
                        href="https://tools.google.com/dlpage/gaoptout"
                        target="_blank"
                        rel="noreferrer"
                      >
                        https://tools.google.com/dlpage/gaoptout
                      </a>
                      .
                    </p>
                  </section>

                  <section>
                    <h3>6. Cookies and Similar Technologies</h3>
                    <p>
                      We use cookies and similar tracking technologies to track
                      activity on our Services and to hold certain information.
                      Cookies are files with a small amount of data that may
                      include an anonymous unique identifier.
                    </p>
                    <p>We use the following types of cookies:</p>
                    <ul>
                      <li>
                        <strong>Essential Cookies:</strong> Necessary for the
                        functioning of our Services.
                      </li>
                      <li>
                        <strong>Analytical/Performance Cookies:</strong> Allow
                        us to recognize and count the number of visitors and see
                        how visitors move around our Services.
                      </li>
                      <li>
                        <strong>Functionality Cookies:</strong> Used to
                        recognize you when you return to our Services.
                      </li>
                    </ul>
                    <p>
                      You can instruct your browser to refuse all cookies or to
                      indicate when a cookie is being sent. However, if you do
                      not accept cookies, you may not be able to use some
                      portions of our Services.
                    </p>
                  </section>

                  <section>
                    <h3>7. Data Sharing and Disclosure</h3>
                    <p>
                      We may share your information in the following situations:
                    </p>
                    <ul>
                      <li>
                        <strong>With Service Providers:</strong> We may share
                        your information with third-party vendors, service
                        providers, and other partners who help us provide our
                        Services (e.g., email delivery services, analytics
                        providers).
                      </li>
                      <li>
                        <strong>For Legal Reasons:</strong> We may disclose your
                        information if we believe it is necessary to comply with
                        a legal obligation, protect and defend our rights or
                        property, prevent fraud, or protect the safety of our
                        users or the public.
                      </li>
                      <li>
                        <strong>With Your Consent:</strong> We may share your
                        information with your consent or at your direction.
                      </li>
                    </ul>
                    <p>
                      We do not sell your personal information to third parties.
                    </p>
                  </section>

                  <section>
                    <h3>8. Data Retention</h3>
                    <p>
                      We will retain your information for as long as your
                      account is active or as needed to provide you with our
                      Services. We will also retain and use your information as
                      necessary to comply with our legal obligations, resolve
                      disputes, and enforce our agreements.
                    </p>
                  </section>

                  <section>
                    <h3>9. Your Rights and Choices</h3>
                    <p>
                      Depending on your location, you may have certain rights
                      regarding your personal information, including:
                    </p>
                    <ul>
                      <li>
                        The right to access and receive a copy of your personal
                        information
                      </li>
                      <li>The right to correct inaccurate information</li>
                      <li>The right to delete your personal information</li>
                      <li>
                        The right to restrict or object to processing of your
                        personal information
                      </li>
                      <li>The right to data portability</li>
                      <li>The right to withdraw consent at any time</li>
                    </ul>
                    <p>
                      To exercise these rights, please contact us at{" "}
                      <a href="mailto:hello@rolepilot.ai">hello@rolepilot.ai</a>
                      .
                    </p>
                  </section>

                  <section>
                    <h3>10. Data Security</h3>
                    <p>
                      We implement appropriate technical and organizational
                      measures to protect your personal information against
                      unauthorized or unlawful processing, accidental loss,
                      destruction, or damage. However, no method of transmission
                      over the Internet or electronic storage is 100% secure,
                      and we cannot guarantee absolute security.
                    </p>
                  </section>

                  <section>
                    <h3>11. International Data Transfers</h3>
                    <p>
                      Your information may be transferred to and processed in
                      countries other than the country in which you reside.
                      These countries may have data protection laws that are
                      different from the laws of your country.
                    </p>
                    <p>
                      By using our Services, you consent to the transfer of your
                      information to countries outside your country of
                      residence, including the United States, where different
                      data protection standards may apply.
                    </p>
                  </section>

                  <section>
                    <h3>12. Children's Privacy</h3>
                    <p>
                      Our Services are not intended for children under the age
                      of 13, and we do not knowingly collect personal
                      information from children under 13. If we learn that we
                      have collected personal information from a child under 13,
                      we will take steps to delete such information as quickly
                      as possible.
                    </p>
                  </section>

                  <section>
                    <h3>13. Changes to This Privacy Policy</h3>
                    <p>
                      We may update our Privacy Policy from time to time. We
                      will notify you of any changes by posting the new Privacy
                      Policy on this page and updating the "Last Updated" date
                      at the top of this Privacy Policy.
                    </p>
                    <p>
                      You are advised to review this Privacy Policy periodically
                      for any changes. Changes to this Privacy Policy are
                      effective when they are posted on this page.
                    </p>
                  </section>

                  <section>
                    <h3>14. Contact Us</h3>
                    <p>
                      If you have any questions about this Privacy Policy,
                      please contact us at{" "}
                      <a href="mailto:hello@rolepilot.ai">hello@rolepilot.ai</a>
                      .
                    </p>
                  </section>
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Container>
    </div>
  );
};

export default TermsAndPrivacy;
